import React from 'react';
import { Box } from '@mui/material';
import { SEARCE_COLORS } from '../../theme';
import type { HealthChip, HealthChipColor } from './executiveSummaryTypes';

const DOT_COLOR: Record<HealthChipColor, string> = {
  green: SEARCE_COLORS.success,
  amber: SEARCE_COLORS.warning,
  red: SEARCE_COLORS.error,
  blue: SEARCE_COLORS.primary,
};

interface HealthChipsProps {
  chips: HealthChip[];
}

const HealthChips: React.FC<HealthChipsProps> = ({ chips }) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', mb: '18px' }}>
    {chips.map((chip) => {
      const isLeading = chip.id === 'next';
      return (
        <Box
          key={chip.id}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '7px',
            px: '14px',
            py: '7px',
            borderRadius: '999px',
            fontSize: '0.75rem',
            fontWeight: 600,
            background: '#fff',
            border: `1px solid ${SEARCE_COLORS.border}`,
            color: SEARCE_COLORS.textSecondary,
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              flexShrink: 0,
              background: DOT_COLOR[chip.color],
            }}
          />
          {isLeading ? (
            <>
              {chip.text}{' '}
              <Box component="strong" sx={{ fontWeight: 700, color: SEARCE_COLORS.textPrimary }}>
                {chip.emphasis}
              </Box>
            </>
          ) : (
            <>
              <Box component="strong" sx={{ fontWeight: 700, color: SEARCE_COLORS.textPrimary }}>
                {chip.emphasis}
              </Box>{' '}
              {chip.text}
            </>
          )}
        </Box>
      );
    })}
  </Box>
);

export default HealthChips;
